function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReactjs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 16.933 16.933",
    id: "react",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-171.45 -431.896)scale(.26458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 674,1664.3627 c 0,3.3017 2.69815,5.9998 6,5.9998 3.30185,0 6,-2.6981 6,-5.9998 0,-3.3018 -2.69815,-5.9999 -6,-5.9999 -3.30185,0 -6,2.6981 -6,5.9999 z m 2.00195,0 c 0,-2.2196 1.77851,-3.998 3.99805,-3.998 2.21954,0 3.99805,1.7784 3.99805,3.998 0,2.2194 -1.77851,3.9959 -3.99805,3.9959 -2.21954,0 -3.99805,-1.7765 -3.99805,-3.9959 z",
    color: "#000",
    enableBackground: "accumulate",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 652,1664.3624 c 0,1.8507 0.93025,3.5596 2.42773,5.0019 1.49749,1.4423 3.57822,2.6723 6.10352,3.7012 5.0506,2.0574 11.90304,3.2969 19.46875,3.2969 7.56571,0 14.41815,-1.2395 19.46875,-3.2969 2.5253,-1.0289 4.60603,-2.2589 6.10352,-3.7012 1.49748,-1.4423 2.42773,-3.1512 2.42773,-5.0019 0,-1.8507 -0.93025,-3.5616 -2.42773,-5.0039 -1.49749,-1.4425 -3.57822,-2.6725 -6.10352,-3.7013 -5.0506,-2.0574 -11.90304,-3.2948 -19.46875,-3.2948 -7.56571,0 -14.41815,1.2374 -19.46875,3.2948 -2.5253,1.0288 -4.60603,2.2588 -6.10352,3.7013 -1.49748,1.4423 -2.42773,3.1532 -2.42773,5.0039 z m 2.00195,0 c 0,-1.1865 0.58148,-2.3713 1.81641,-3.5606 1.23493,-1.1894 3.10825,-2.3275 5.46875,-3.289 4.721,-1.9234 11.36764,-3.1486 18.71289,-3.1486 7.34525,0 13.99189,1.2252 18.71289,3.1486 2.3605,0.9615 4.23382,2.0996 5.46875,3.289 1.23493,1.1893 1.81641,2.3741 1.81641,3.5606 0,1.1864 -0.58148,2.3691 -1.81641,3.5586 -1.23493,1.1893 -3.10825,2.3294 -5.46875,3.291 -4.721,1.9232 -11.36764,3.1465 -18.71289,3.1465 -7.34525,0 -13.99189,-1.2233 -18.71289,-3.1465 -2.3605,-0.9616 -4.23382,-2.1017 -5.46875,-3.291 -1.23493,-1.1895 -1.81641,-2.3722 -1.81641,-3.5586 z",
    color: "#000",
    enableBackground: "accumulate",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 694.59603,1689.6191 c 1.61209,-0.9298 2.6028,-2.63 3.06505,-4.6966 0.46229,-2.0666 0.43781,-4.5519 0.008,-7.3392 -0.85883,-5.5746 -3.36252,-12.3717 -7.30751,-19.1976 -3.94499,-6.8259 -8.58567,-12.3906 -12.98886,-15.9208 -2.20157,-1.7652 -4.34391,-3.029 -6.36661,-3.6624 -2.02266,-0.6333 -3.992,-0.6264 -5.60409,0.3034 -1.61208,0.9299 -2.6011,2.6291 -3.06339,4.6957 -0.46225,2.0666 -0.43777,4.5519 -0.008,7.3391 0.85883,5.5746 3.36256,12.3718 7.30755,19.1977 3.94499,6.8259 8.58562,12.3905 12.98881,15.9207 2.20163,1.7653 4.34396,3.029 6.36662,3.6624 2.0227,0.6334 3.99035,0.6274 5.60243,-0.3024 z m -1.00269,-1.7349 c -1.00968,0.5824 -2.32767,0.6511 -4.00327,0.1264 -1.67562,-0.5247 -3.64262,-1.6532 -5.70991,-3.3107 -4.13456,-3.3148 -8.66821,-8.7181 -12.50782,-15.3617 -3.83966,-6.6437 -6.25698,-13.2676 -7.06341,-18.5021 -0.40319,-2.6171 -0.398,-4.8831 -0.0151,-6.5951 0.38299,-1.7119 1.10154,-2.8178 2.11121,-3.4002 1.00968,-0.5822 2.32766,-0.6509 4.00323,-0.1264 1.67561,0.5247 3.64435,1.6523 5.71159,3.3096 4.13456,3.3149 8.66652,8.7192 12.50618,15.3629 3.83961,6.6436 6.25862,13.2665 7.06505,18.5009 0.40324,2.6173 0.39632,4.8842 0.0134,6.5962 -0.38295,1.7119 -1.10148,2.8178 -2.11116,3.4002 z",
    color: "#000",
    enableBackground: "accumulate",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 665.40413,1689.6191 c -1.61218,-0.9299 -2.60286,-2.6301 -3.06522,-4.6968 -0.46227,-2.0667 -0.43871,-4.5503 -0.009,-7.3377 0.85878,-5.5748 3.36356,-12.3738 7.30861,-19.2 3.94505,-6.8261 8.5857,-12.3909 12.98902,-15.9213 2.20163,-1.7652 4.34296,-3.0274 6.36567,-3.6608 2.02275,-0.6333 3.99206,-0.6264 5.60425,0.3035 1.6121,0.9298 2.60113,2.6291 3.0634,4.6958 0.46223,2.0666 0.4388,4.5503 0.009,7.3377 -0.85887,5.5747 -3.36256,12.372 -7.30761,19.1982 -3.94505,6.8261 -8.58679,12.3926 -12.99001,15.9229 -2.20165,1.7654 -4.34311,3.0275 -6.36577,3.6609 -2.02266,0.6334 -3.99033,0.6274 -5.60243,-0.3024 z m 1.00271,-1.735 c 1.00962,0.5823 2.32662,0.6528 4.00225,0.128 1.67567,-0.5245 3.64366,-1.655 5.71103,-3.3123 4.1346,-3.3149 8.66827,-8.7185 12.50799,-15.3624 3.83966,-6.6438 6.25607,-13.2661 7.06252,-18.5007 0.40317,-2.6174 0.39901,-4.8851 0.016,-6.5972 -0.38294,-1.712 -1.10154,-2.8178 -2.11116,-3.4002 -1.0097,-0.5823 -2.32766,-0.6511 -4.00329,-0.1264 -1.6757,0.5247 -3.64539,1.6539 -5.71272,3.3115 -4.1346,3.3149 -8.66562,8.7176 -12.50529,15.3615 -3.83971,6.6439 -6.25877,13.267 -7.06523,18.5016 -0.4032,2.6172 -0.39736,4.8859 -0.0143,6.598 0.38294,1.7119 1.10249,2.8162 2.1122,3.3986 z",
    color: "#000",
    enableBackground: "accumulate",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactjs);
export default __webpack_public_path__ + "static/media/reactjs.3e7913c5dc0c8613ac1287e6dd8bc512.svg";
export { ForwardRef as ReactComponent };